import React from 'react'
import PropTypes from 'prop-types'
import GenericButton from '../GenericButton'
import Lightbox from '../Lightbox'
import Review from './Review'

import styles from './reviews.module.scss'
import styled from 'styled-components'

class ProductReviews extends React.Component {
  state = {
    modalIsOpen: false,
    currentIndex: 0,
  }
  closeModal = (event) => {
    if (window.$(event.target).closest(`.lightbox-view`).length) {
      return
    }
    this.setState({
      modalIsOpen: false,
      currentIndex: 0,
    })
  }
  openModal = (index) => (event) => {
    event.preventDefault()
    this.setState({
      modalIsOpen: true,
      currentIndex: index,
    })
  }
  createMarkup(html) {
    return { __html: html }
  }
  render() {
    const { modalIsOpen, currentIndex } = this.state
    const {
      title,
      reviews: { path, content },
      withoutTitle,
      onPlatform,
    } = this.props
    return content && content.length ? (
      <div className={styles.root}>
        {!withoutTitle && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.reviews}>
          {content.map((review, index) => (
            <Review
              key={review.id}
              content={review}
              onClick={this.openModal(index)}
            />
          ))}
        </div>
        <Lightbox
          items={content.map(({ photo: source, ...captionContent }) => ({
            source,
            captionContent,
          }))} // need create content {source, и т.д.}
          isOpen={modalIsOpen}
          currentIndex={currentIndex}
          captionRender={({
            captionContent: { author, date, comments, orderedProducts },
          }) => (
            <div>
              <div className={styles.reviewHeader}>
                <span className={styles.author}>{author}</span>
                <span className={styles.date}>{date}</span>
                <div className={styles.order}>
                  <span>В заказе: </span>
                  <span
                    dangerouslySetInnerHTML={this.createMarkup(orderedProducts)}
                  />
                </div>
              </div>
              <div className={styles.reivewComments}>{comments}</div>
            </div>
          )}
          onClose={this.closeModal}
        />
        {onPlatform !== `vtb` && (
          <div className={styles.footer}>
            <a href={path}>
              <ReviewsButton>Перейти ко всем отзывам</ReviewsButton>
            </a>
          </div>
        )}
      </div>
    ) : null
  }
}

const ReviewsButton = styled(GenericButton)`
  color: #2a3133;
  background-color: #f5f6f6;
  padding: 8px 16px;
  font-size: 15px;
  line-height: 1.6;
  height: 40px;
  font-weight: 500;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;

  &:hover {
    background-color: #eff1f1;
  }
`

ProductReviews.propTypes = {
  title: PropTypes.string,
  reviews: PropTypes.shape({
    counts: PropTypes.number,
    path: PropTypes.string,
    content: PropTypes.array,
  }),
  withoutTitle: PropTypes.bool,
  onPlatform: PropTypes.string,
}

export default ProductReviews
